export const CONVERSIONS_TABS = {
    EVENTS_ON_THIS_PAGE: 'EventsOnThisPage',
    ALL_YOUR_EVENTS: 'AllYourEvents',
};
